export class IssueItemViewModel {
    // #region Properties

    public rfiId: string = "";
    public categoryName: string = "";
    public rfis: any[] = [];

    // #endregion Properties
}
